import { FC } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { EditOutlined, RemoveRedEyeOutlined } from "@mui/icons-material";
import { Tooltip } from "@mui/material";

import { DispatchProperties } from "../../../../redux/store";
import { clearErrors } from "../../../../redux/State/clientSlice/soapNoteSlice";
import { SoapNotesFullProperties } from "../../../../redux/API/ClientAPIHelpers/soapNoteProperties";
import { clearSessionInfo } from "../../../../redux/State/clientSlice/sessionSlice";

const Edit: FC<{
  data: SoapNotesFullProperties;
  isViewOnly: boolean;
}> = ({ data, isViewOnly }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch<DispatchProperties>();

  const { id, client, sessionId } = data;

  const navigateSoapNoteHandler = () => {
    dispatch(clearErrors());
    dispatch(clearSessionInfo());
    const query = new URLSearchParams();
    query.set("reportId", id);
    query.set("sessionId", sessionId);
    query.set("clientId", client.id);
    navigate(`/soap-notes/edit?${query.toString()}`);
  };

  const Icon = isViewOnly ? RemoveRedEyeOutlined : EditOutlined;

  return (
    <Tooltip title={isViewOnly ? "View" : "Edit"}>
      <Icon fontSize="small" onClick={navigateSoapNoteHandler} />
    </Tooltip>
  );
};

export default Edit;
